<template>
  <b-modal
    v-model="trigger"
    :centered="true"
    :no-close-on-backdrop="dontCloseWhenClickedOutside"
    :no-close-on-esc="dontCloseWhenEscapePressed"
    :hide-header-close="dontShowCloseIcon"
    :hide-footer="true"
    :hide-header="true"
    @cancel="eventCancel($event)"
  >
    <div class="empanel-modal-close">
      <span v-if="!isEdit" class="Modal-head-text">Add New Address</span>
      <span v-if="isEdit" class="Modal-head-text">Edit {{editAddress.addressType}}</span>
      <p class>
        <img
          @click="closeContactModal()"
          class="cursor-pointer modal-close-button mt-n1"
          style="float:right"
          src="@/assets/images/close1.svg"
        />
      </p>
    </div>
    <div class="card contact-card">
      <div class="row" style="padding:10px;">        
        
              <div class="col-12" :class="isEdit ? 'disabled-field' : ''">
                <div class="field-hd">Address Type</div>
              <select v-model="addrForm.addressTypeCode" placeholder="select address type"  class="form-control" maxlength="200">
                <option value="" selected>Select Address type</option>
                <option v-for = "i in addressTypes" :key ="i" :value="i.addressTypeCode" selected>{{i.addressTypeDesc}}</option>
                
              </select></div> 
              <div class="col-12"><div class="field-hd">Address line</div>
              <input v-model="addrForm.streetAddress" class="form-control" maxlength="200"
              placeholder="Minimum 10 characters"/></div>   
              <div class="col-12"><div class="field-hd">Country</div>
              <select v-model="addrForm.countryCode" class="form-control" @change="getStateForRegdOffice(addrForm.countryCode)">
              <option v-for="c in countryList" :key="c" :value="c.value">{{c.text}}</option>
              </select></div>   
              <div class="col-12"><div class="field-hd">State</div>
              <select v-model="addrForm.stateCode" class="form-control" @change="getCityForRegdOffice(addrForm.stateCode)"
              :class="stateList.length > 0 ? '': 'disabled'">
              <option v-for="s in stateList" :key="s" :value="s.value">{{s.text}}</option>
              </select></div>
              <div class="col-12"><div class="field-hd">City</div>
              <select v-model="addrForm.cityCode" class="form-control" :class="cityList.length > 0 ? '': 'disabled'">
              <option v-for="c in cityList" :key="c" :value="c.value">{{c.text}}</option>
              </select></div>   
              <div class="col-12"><div class="field-hd">Zip Code</div>
              <input v-model="addrForm.postalCode" class="form-control" maxlength="10" @keypress="isNumber($event, newMobile)"/>
              </div>  

              <div class="col-12"><div class="field-hd">Is SEZ:</div>
      <input type="radio" id="one" :value="'Y'" v-model="addrForm.sezTag">
        <label style="padding-left: 5px;" for="one">Yes</label> &nbsp;&nbsp;
       <input type="radio" id="two" :value="'N'" v-model="addrForm.sezTag">
       <label style="padding-left: 5px;" for="two">No</label>
                 
              </div> 
              </div>
    <div class="row">
    <div class="col-12">
      <FileUploader
        class="text-left ml-4"
        :id="'documentId'"
        :heading="'Attach Address proof or Relevant documents*'"
        @fileInputChange="getAddrAttachment($event)"
      />
      <div class="col-10 ml-4 mt-1 p-0 pt-1" v-if="addrForm.documentId">
        <ul style="list-style-type:disc;">
          <li>
            <a
              @click="showAttachFile(addrForm.documentId)"
              href="#"
            >{{getFileName(addrForm.documentId)}}</a>
          </li>
        </ul>
      </div>
    </div>
    </div>

      <div class="row mt-3 mr-1">
        <!-- <div class="col-8"></div> -->
        <div class="col">
          <b-button
            v-if="!isEdit"
            class="ml-2 button-class"
            @click="saveAddress(isEdit)"
          >Save</b-button>
          <b-button
            v-if="isEdit"
            class="ml-2 button-class"
            @click="saveAddress(isEdit)"
          >Update</b-button>
        </div>
      </div>
    </div>
    <w-loadingSpinner :loadSpinner="loading" />
  </b-modal>
</template>
<script>
import TextInput from "./TextInput";
import DropDown from "../widgets/DropDown";
import FileUploader from "../widgets/FileUploader";
import loadingSpinner from "../widgets/LoadingSpinner";
import { OnBoardingServices } from "../services/onBoardingService";
import { PartnerService } from "../services/partnerService";
// import VeeValidate from "vee-validate";
const OnBoardingService = new OnBoardingServices();
const partnerService = new PartnerService();
import { RegistrationService } from "../services/RegistrationService.js";
const RegisterService = new RegistrationService();

export default {
  components: {
    "w-text-input": TextInput,
    "w-dropdown": DropDown,
    "w-loadingSpinner": loadingSpinner,
    FileUploader
  },
  props: [
    "trigger",
    "dontCloseWhenClickedOutside",
    "dontShowCloseIcon",
    "dontCloseWhenEscapePressed",
    "editAddress",
    "isEdit",
    "categoryCode",
    "partnerId",
    "userId"
  ], 
  created() {
    this.getPartnerInfo();
    this.getCountriesForRegdOffice();
    this.addrForm = {
        "addressTypeCode": "",
        "categoryCode": this.categoryCode,
        "cityCode": "",
        "companyCode": this.companycode,
        "countryCode": "",
        "documentId": "",
        "gstNumber": null,
        "isEdit": this.isEdit ? 'Y' : 'N',
        "partnerId": this.partnerId,
        "postalCode": "",
        "sezTag": "",
        "siteUrl": "",
        "slno": "",
        "stateCode": "",
        "streetAddress": "",
        "userId": this.userId
        };
    if (this.isEdit) {
      this.addrForm.slno = this.editAddress.slno
      this.addrForm.streetAddress = this.editAddress.streetAddress;
      this.addrForm.countryCode = this.editAddress.countryCode;
      this.getStateForRegdOffice(this.editAddress.countryCode) 
      this.addrForm.stateCode = this.editAddress.stateCode;
      this.getCityForRegdOffice(this.editAddress.stateCode) 
      this.addrForm.cityCode = this.editAddress.cityCode;
      this.addrForm.postalCode = this.editAddress.zipCode;
      this.addrForm.documentId = this.editAddress.documentId;
      this.addrForm.siteUrl = this.editAddress.siteUrl;
      this.addrForm.addressTypeCode = this.editAddress.addressTypeCode
      this.addrForm.sezTag = this.editAddress.sezTag ? this.editAddress.sezTag : 'N'
    }
  },
  computed() {
    console.log(this.contact);
  },
  data() {
    return {
      addressTypes: [{"addressTypeCode":1,"addressTypeDesc":"Correspondence/Communication Address"},
      {"addressTypeCode":3,"addressTypeDesc":"Registered Office Address"}],
      addrForm: {
        "addressTypeCode": "",
        "categoryCode": "",
        "cityCode": "",
        "companyCode": "",
        "countryCode": "",
        "documentId": "",
        "gstNumber": null,
        "isEdit": "",
        "partnerId": "",
        "postalCode": "",
        "sezTag": "",
        "siteUrl": "",
        "slno": "",
        "stateCode": "",
        "streetAddress": "",
        "userId": ""
        },
      countryList: [],      
      stateList:[],
      cityList:[],
      companycode: "",
      categorycode: "",
      loading: false
    };
  },
  methods: {    
    isNumber(event, message) {
      if (!/\d/.test(event.key))   
        return event.preventDefault();  
    },
    getAddrAttachment(event) {
      this.loading = true;
      this.formChanged = true;
      console.log(event[0]);
      let data = new FormData();
      let file = event[0];
      console.log(file);
      // data.append("name", "my-file");
      data.append("file", file);
      OnBoardingService.uploadAttachments(data).then(resp => {
        this.loading = false;
        if (resp) {
          this.addrForm.documentId = resp.UniqueID;
          this.addrForm.siteUrl = resp.SiteUrl;
        }
      });
    },
    showAttachFile(event) {
      this.loading = true;
      OnBoardingService.downLoadDocument(event)
        .then(res => {
          this.loading = false;
        })
        .catch(e => {
                window.alert("Something went wrong! try again later");
          this.loading = false;
        });
    },
    getFileName(fileName) {
      var fileNameFinal = "";
      fileNameFinal = fileName.split(/_(.+)/)[1];
      return fileNameFinal;
    },
    isDisabledSubmitUpdateRegOfc() {
      if(this.addrForm.streetAddress.trim().length<10 || !this.addrForm.countryCode ||
       !this.addrForm.stateCode || !this.addrForm.cityCode || this.addrForm.postalCode.trim().length < 6) {
      return 'disabled'
     } else {
       return ''
     }
    },
    getCountriesForRegdOffice() {
      this.countryList = [];
      var self = this
      OnBoardingService.getCountriesForRegdOffice().then(resp => {
        resp.response.forEach(country => {
          this.countryList.push({
            text: country.longDesc,
            value: country.countryCode
          });
        });
      });
    },    
    getStateForRegdOffice(countryCode) {
      this.stateList = [];
      OnBoardingService.getStatesForRegisteredOffice(
        countryCode
      ).then(resp => {
        resp.response.forEach(state => {
          this.stateList.push({
            text: state.longDescr,
            value: state.stateCode
          });
        });
      });
    },    
    
    getCityForRegdOffice(stateCode) {
      this.cityList = [];
      OnBoardingService.getCityForRegisteredOffice(stateCode).then(resp => {
        resp.response.forEach(city => {
          this.cityList.push({
            text: city.cityName,
            value: city.cityCode
          });
        });
      });
    },
    mobileValidationObj(){
      if(!this.$root.isInternational){
        return {required: true, regex_mobile_number: true, length: this.phoneNumberLength}
      } else {
        return {required: true, min:6}
      }     
    },
    getContactCategoryDropdown() {
      let dropdownValues = [
        { value: "P", text: "Primary" },
        { value: "S", text: "Secondary" }
      ];
      this.contactCategories = dropdownValues;
    },
    getPartnerInfo() {
      partnerService.getPartnerInfo().then(resp => {
        this.companycode = resp.response.currentCompanyCode;
        this.addrForm.companyCode = resp.response.currentCompanyCode;
        this.$root.isInternational =
              resp.response.countryDetail.countryCode == 100 ? false : true;
      });
    },
    closeContactModal(event) {
      // this.emptyContact();
      //   console.log(this.contact);
      this.$emit("eventClose", event);
    },
    isFormValid(){
      Object.entries(this.addrForm).forEach(item => {
         if(item[0]!='gstNumber' && item[0]!='slno' && (item[1] == null || item[1] == undefined || (typeof item[1] === 'string' && item[1].trim() == '')))
         {
           return false
         }
      })
      return true
    },
    saveAddress(isEdit) {
      this.loading = true;
      var isValidForm = this.isFormValid()
      if (isValidForm) {
        partnerService
          .addressQL(this.addrForm)
          .then(res => {
            if (res.response) {
              this.loading = false;
              this.$emit("afterSave");
              this.isEdit = false;
            }
            if (res.failureMessage) {
              //this.$emit("alertOnSave", res.failureMessage); 
                window.alert(res.failureMessage);
              this.loading = false;
            }
          })
          .catch(e => {
                window.alert("Something went wrong! try again later");
            this.loading = false;
          });
      } else {
           window.alert('Form incomplete!. Please ensure all fields are valid and attachment is uploaded!')
      }
    }
  }
};
</script>
<style scoped>
.disabled-field{  
  cursor: none;
    pointer-events: none;
    opacity: 0.5;
    user-select: none;
}
.empanel-modal-close {
  padding: 8px !important;
  background-image: linear-gradient(to bottom, #1d76ae, #055396);
  border: 0.1px;
}
.empanel-modal-close {
  padding: 8px !important;
  background-image: linear-gradient(to bottom, #1d76ae, #055396);
  border: 0.1px;
}
.empanel-modal-close {
  padding: 8px !important;
  background-image: linear-gradient(to bottom, #1d76ae, #055396);
  border: 0.1px;
}
.field-hd {
  padding-bottom:3px;
}
.button-class {
  width: 100px;
  height: 30px;
  font-family: "Source Sans Pro", sans-serif;
  font-size: 14px;
  color: white !important;
  border-radius: 2px;
  background-color: #1579ab;
  margin-bottom: 30px;
  display: block;
  margin-left: auto !important;
  margin-right: auto !important;
}
.button-class:disabled {
  color: white !important;
}
</style>